import { useTranslation } from 'react-i18next';
import { FormEvidence } from '../../../../components/form/FormEvidence';
import { FormSelect } from '../../../../components/form/FormSelect';
import { FormTextEditor } from '../../../../components/form/FormTextEditor';
import { projectFormValidations } from '../form';

export const MonitoringPlan = (props) => {
  const { register, watch, errors, control, evidenceList, updatedEvidence } = props;
  const { t, i18n } = useTranslation();
  const validations = projectFormValidations(i18n.language === 'en');
  const isEn = i18n.language === 'en';

  return (
    <article className='flex flex-col gap-4 w-[945px] mb-4 pb-8'>
      {evidenceList?.length > 0 && (
        <article className='pb-8'>
          <header>
            <h2>{t('METHODOLOGY') + ' ' + t('SUPPORTING_DOC')}</h2>
          </header>
          {/* readOnly일 경우, type이 Modify일 경우 텍스트 박스, 아닐 경우 셀렉트박스 */}
          <article className='flex flex-col gap-4 p-4 mt-4 border bg-slate-100 rounded-md'>
            <div>
              <FormEvidence
                control={control}
                name='evidence'
                rules={{ required: validations?.evidence?.required }}
                error={errors.evidence}
                updatedEvidence={updatedEvidence}
                labels={evidenceList?.map((item) => ({
                  title: isEn ? item.evidence?.titleEn || item.evidence?.title : item.evidence?.title,
                  isForce: item.isForce,
                  seq: item.evidence?.seq || item.evidenceSeq,
                }))}
                disabled={false}
                readOnly={false}
              />
            </div>
          </article>
        </article>
      )}
      <header>
        <h2>{t('MONITORING_PLAN_INPUT')}</h2>
      </header>
      <FormSelect
        label={t('MONITORING_PLAN_METHOD')}
        required
        menus={[
          { label: t('PAPER_MONITORING'), value: 'Document' },
          { label: t('SYSTEM_MONITORING'), value: 'System' },
        ]}
        rules={{ required: validations?.monitoringType?.required }}
        error={errors.monitoringType}
        name='monitoringType'
        control={control}
      />
      <FormTextEditor
        label={t('REDUCTION_MONITORING_PLAN_EXP')}
        required
        error={errors.monitoringPlan}
        control={control}
        rules={validations?.monitoringPlan}
        name='monitoringPlan'
      />
    </article>
  );
};
